import { WebLink } from '@news-mono/web-common'
import React from 'react'
import {
    StyledBackgroundWrap,
    StyledCNBCLogo,
    StyledFeatureContainer,
    StyledFeatureSectionHeader,
    StyledGradientSectionTitle,
    StyledGradientWrap,
    StyledPollieRaterBanner,
    StyledPollieRaterBannerButton,
    StyledPollieRaterBannerTitle,
    StyledPollieRaterBannerWrap,
    StyledThor,
} from '../../compositions/Thor/Thor.styled'
import { QueensLegacyLogo } from '../../logos/QueensLegacy/QueensLegacyLogo'
import { TheWestHomeOfGrandFinalLogo } from '../../logos/TheWestLogoGrandFinal/TheWestHomeOfGrandFinalLogo'
import { ThemeOverrider } from '../../themes/ThemeOverrider/ThemeOverrider'
import { ContainerWidth, ThemeMargins } from '../../__styling/settings/metrics'
import { ThemeOverrideTypes } from '../../__styling/themes'

export interface ThorProps {
    mainContent: React.ReactElement<any>
    hasBackgroundFill?: boolean
    /** If true or undefined, will default to the outer margin of the theme */
    horizontalGutters?: boolean | keyof ThemeMargins
    /** If true or undefined, will default to the outer margin of the theme */
    verticalGutters?: boolean | keyof ThemeMargins
    verticalSpacing?: keyof ThemeMargins
    containerWidth?: ContainerWidth
    themeOverride?: ThemeOverrideTypes
    hideHeadingLink?: boolean
}

export const Thor: React.FC<ThorProps> = ({
    mainContent,
    hasBackgroundFill,
    horizontalGutters,
    verticalGutters,
    verticalSpacing,
    containerWidth,
    themeOverride,
    hideHeadingLink,
}) => {
    const styledThor = (
        <StyledThor
            hasBackgroundFill={hasBackgroundFill}
            horizontalGutters={horizontalGutters}
            verticalGutters={verticalGutters}
            verticalSpacing={verticalSpacing}
            containerWidth={containerWidth || 1020}
        >
            {mainContent}
        </StyledThor>
    )
    if (themeOverride === 'grand-final') {
        return (
            <ThemeOverrider override={themeOverride}>
                <StyledBackgroundWrap>
                    <StyledFeatureContainer>
                        <WebLink to="/sport/afl">
                            <TheWestHomeOfGrandFinalLogo logoWidth={256} />
                        </WebLink>

                        <StyledFeatureSectionHeader
                            heading="Full Coverage"
                            headingUrl="/sport/afl"
                            showChevron={true}
                        />
                    </StyledFeatureContainer>
                    {styledThor}
                </StyledBackgroundWrap>
            </ThemeOverrider>
        )
    }

    if (themeOverride === 'queens-legacy') {
        return (
            <ThemeOverrider override={themeOverride}>
                <StyledFeatureContainer>
                    <WebLink to="/news/queen-elizabeth-ii">
                        <QueensLegacyLogo logoWidth={400} />
                    </WebLink>

                    <StyledFeatureSectionHeader
                        heading="More Stories"
                        headingUrl="/news/queen-elizabeth-ii"
                        showChevron={true}
                    />
                </StyledFeatureContainer>
                {styledThor}
            </ThemeOverrider>
        )
    }

    if (themeOverride === 'cnbc') {
        //We don't want to display anything if we don't have any content.
        if (!mainContent) {
            return (
                <ThemeOverrider override={themeOverride}>
                    {styledThor}
                </ThemeOverrider>
            )
        }

        const CNBCLogoSource = require('../../logos/CNBCLogos/CNBC_Logo_White.png')

        return (
            <ThemeOverrider override={themeOverride}>
                <StyledFeatureContainer>
                    <WebLink to="/business/cnbc">
                        <StyledCNBCLogo src={CNBCLogoSource} />
                    </WebLink>
                    <StyledFeatureSectionHeader
                        heading="More stories"
                        headingUrl="/business/cnbc"
                        showChevron
                    />
                </StyledFeatureContainer>
                {styledThor}
            </ThemeOverrider>
        )
    }

    if (themeOverride === 'federal-election') {
        return (
            <StyledGradientWrap>
                <StyledFeatureContainer>
                    <StyledGradientSectionTitle>
                        Federal Election 2022
                    </StyledGradientSectionTitle>
                    <StyledFeatureSectionHeader
                        heading="Full Coverage"
                        headingUrl="/federal-election"
                        showChevron={true}
                    />
                </StyledFeatureContainer>
                <StyledPollieRaterBannerWrap>
                    <StyledPollieRaterBanner>
                        <StyledPollieRaterBannerTitle>
                            Rate the politicians running in the election!
                        </StyledPollieRaterBannerTitle>
                        <StyledPollieRaterBannerButton to="/politics/federal-election/pollie-rater">
                            Rate the politicians
                        </StyledPollieRaterBannerButton>
                    </StyledPollieRaterBanner>
                </StyledPollieRaterBannerWrap>
                {styledThor}
            </StyledGradientWrap>
        )
    }

    return (
        <ThemeOverrider override={themeOverride}>{styledThor}</ThemeOverrider>
    )
}

Thor.displayName = 'ThorComposition'
